import { API } from 'app/utils/client';
import { IConfirmation, IResponse } from 'app/models';
import { APIService } from './api';

export class ConfirmationService extends APIService {
  public async query(params: any) {
    return this.intercept((c, p) => c.get<IResponse<IConfirmation[]>>(p, { params }));
  }

  public async get(id: any) {
    return this.intercept((c, p) => c.get<IResponse<IConfirmation>>(`${p}/${id}`));
  }

  public async approve({ id }: IConfirmation) {
    return this.intercept((c, p) => c.patch<IResponse<IConfirmation>>(`${p}/${id}`));
  }

  public async reject({ id, reason }: IConfirmation) {
    return this.intercept((c, p) => c.delete<IResponse<IConfirmation>>(`${p}/${id}`, { params: { reason } }));
  }
}

const instance = new ConfirmationService(API, 'v1/confirmations');
export default instance;
